import {IntlProvider as ReactIntlProvider} from 'react-intl';

import BGlang from 'src/locale/bg/lang.json';
import ENlang from 'src/locale/en/lang.json';
import {storage} from 'src/utils/storage';
import {LOCALE} from 'src/providers/types';

type i18n = {
    locale: LOCALE;
    messages: { [id: string]: string };
};

const getLocaleMessages = (locale: LOCALE) => {
    switch (locale) {
        case LOCALE.BG:
            return BGlang;
        case LOCALE.EN:
            return ENlang;
        default:
            return BGlang;
    }
};

type IntlProviderProps = {
    children?: React.ReactNode;
};

const IntlProvider = ({ children }: IntlProviderProps) => {
    // We check if localStorage holds a language preference, if not we default to bulgarian for now...
    const localLanguage = (storage.getLanguage()?.split('-')[0] as LOCALE) || LOCALE.BG;

    const i18n: i18n = {
        locale: localLanguage,
        messages: getLocaleMessages(localLanguage),
    };

    return (
        <ReactIntlProvider locale={i18n.locale} messages={i18n.messages}>
            {children}
        </ReactIntlProvider>
    );
};

export { IntlProvider };
